export const buttonSx = {
  '&:hover': {
    boxShadow: 'none',
  },
  '&.MuiButton-contained:hover': {
    bgcolor: '#b0072f',
  },
  '&.MuiButton-contained:focus': {
    bgcolor: '#930627',
  },
  '&.MuiButton-outlined:hover': {
    bgcolor: '#f6f6f6',
  },
  '&.MuiButton-outlined:focus': {
    bgcolor: '#ebebeb',
  },
};
